import { api } from "../utils/api";

const getAccessionActions = async () => {
  const response = await api.get("Settings/accessionActions");
  return response.data;
};

const getCommunicationVariables = async () => {
  const response = await api.get("Settings/communicationVariables");
  return response.data;
};

const getHomeText = async () => {
  const response = await api.get("Settings/homeText");
  return response.data;
};

const setHomeText = async data => {
  const response = await api.put("Settings/homeText", data);
  return response.data;
};

const SettingsService = {
  getAccessionActions,
  getCommunicationVariables,
  getHomeText,
  setHomeText
};

export default SettingsService;
